/**
 * The campaign cost estimate's own catalogue (frame 132:555). No other
 * module writes to it -- each screen carries its own, same reasoning as
 * `../../control/panel/tree.messages.ts`. `kind.*` mirrors that file's own
 * media-kind labels; kept here rather than imported because there is no
 * shared control/campaign message catalogue to import it from.
 */

import { defineCatalogue } from '../../../i18n';

export const estimateCatalogue = defineCatalogue(
  {
    title: 'Estimativa de custo',
    lead: 'Quanto esta campanha deve gastar por dia, estimado por operação.',

    'stat.day': 'Estimativa por dia',
    'stat.30d': 'Estimativa em 30 dias',
    'stat.actual7d': 'Gasto real nos últimos 7 dias',
    'stat.actualNone': 'Ainda sem gasto registrado nos últimos 7 dias.',
    unpriced: 'sem preço',

    'breakdown.title': 'Por operação',
    'breakdown.lead': 'Estimativa de créditos por dia, por operação.',

    'kind.POST': 'Publicações',
    'kind.REEL': 'Reels',
    'kind.STORY': 'Stories',

    'commentLimit.title': 'E se o limite de comentários fosse removido?',
    'commentLimit.lead':
      'Arraste para ver quanto a estimativa mudaria sem o limite de comentários por publicação. Nada aqui é salvo.',
    'commentLimit.label': 'Limite de comentários por publicação',
    'commentLimit.value': '{percent}% do efeito de remover o limite',
    'commentLimit.current': 'Como está hoje',
    'commentLimit.uncapped': 'Sem limite',

    'credits.title': 'Para onde vão os créditos',
    'credits.column.account': 'Conta',
    'credits.column.handleNone': 'Sem usuário',
    'credits.column.perDay': 'Por dia',
    'credits.column.per30d': 'Em 30 dias',
    'credits.table.caption': 'Consumo estimado por conta',

    'empty.title': 'Nenhuma operação ativada',
    'empty.body':
      'Assim que uma conta tiver operações ativadas nesta campanha, a estimativa aparece aqui.',
  },
  {
    title: 'Cost estimate',
    lead: 'What this campaign is expected to spend per day, estimated by operation.',

    'stat.day': 'Estimated per day',
    'stat.30d': 'Estimated over 30 days',
    'stat.actual7d': 'Actual spend, last 7 days',
    'stat.actualNone': 'No spend recorded yet in the last 7 days.',
    unpriced: 'no price',

    'breakdown.title': 'By operation',
    'breakdown.lead': 'Estimated credits per day, by operation.',

    'kind.POST': 'Posts',
    'kind.REEL': 'Reels',
    'kind.STORY': 'Stories',

    'commentLimit.title': 'What if the comment limit were removed?',
    'commentLimit.lead':
      'Drag to see how the estimate would change without the per-post comment limit. Nothing here is saved.',
    'commentLimit.label': 'Comment limit per post',
    'commentLimit.value': '{percent}% of the effect of removing the limit',
    'commentLimit.current': 'As it is today',
    'commentLimit.uncapped': 'No limit',

    'credits.title': 'Where the credits go',
    'credits.column.account': 'Account',
    'credits.column.handleNone': 'No username',
    'credits.column.perDay': 'Per day',
    'credits.column.per30d': 'Per 30 days',
    'credits.table.caption': 'Estimated spend, by account',

    'empty.title': 'No operations enabled',
    'empty.body':
      'Once an account has operations enabled in this campaign, the estimate shows up here.',
  },
);

export const et = estimateCatalogue.t;
